// @flow
export const phoneNumberToString = (phoneNumbers: PhoneNumber[]):string[] => {
  const phones:string[] = phoneNumbers.map(p => {
    let text = p.number
    if (p.extension) {
      text += ` ต่อ ${p.extension}`
    }
    return text
  })
  return phones
}